import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Session } from './session';
import { AppVersion } from './version';

export const SESSION = new InjectionToken<Session>('session');
export const PAGETITLE = new InjectionToken<BehaviorSubject<string>>('pagetitle');
export const VERSION = new InjectionToken<AppVersion>('Application Version');
